import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { RecintoService } from './recinto.service';
import { CoreModule } from 'src/app/components/core/core.module';
import { RecintoRoutingModule } from './recinto-routing.module';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { NgSelectModule } from '@ng-select/ng-select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RecintoFilterComponent } from './recinto-filter/recinto-filter.component';
import { RecintoEditComponent } from './recinto-edit/recinto-edit.component';
import { RecintoListComponent } from './recinto-list/recinto-list.component';
import { RecintoWrapperEditComponent } from './recinto-wrapper-edit/recinto-wrapper-edit.component';
import { RecintoWrapperComponent } from './recinto-wrapper/recinto-wrapper.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RecintoListDialogComponent } from './recinto-list-dialog/recinto-list-dialog.component';
import { RecintoDetailDialogComponent } from './recinto-detail-dialog/recinto-detail-dialog.component';
import { CultivoModule } from '../cultivos/cultivo.module';
import { AppModuleGlobalShared } from 'src/app/app.module.global';

@NgModule({
    declarations: [
        RecintoWrapperComponent,
        RecintoListComponent,
        RecintoFilterComponent,
        RecintoEditComponent,
        RecintoWrapperEditComponent,
        RecintoListDialogComponent,
        RecintoDetailDialogComponent,
    ],
    imports: [
        CultivoModule,
        ProgressSpinnerModule,
        NgbModule,
        SelectButtonModule,
        NgSelectModule,
        TableModule,
        PaginatorModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RecintoRoutingModule,
        CoreModule,
        AppModuleGlobalShared, // Pipes y componentes de PrimeNg, CoreUI o demás de formularios
    ],
    providers: [ExceptionManager, RecintoService],
    exports: [RecintoListComponent, RecintoListDialogComponent, RecintoDetailDialogComponent],
})
export class RecintoModule {}
